import type { Client } from 'openapi-fetch';

import type { EmsPaths } from '../api/ems';

export type AgencyConfigurationDto =
  EmsPaths['/portal/v1/configuration']['get']['responses'][200]['content']['application/json'];

export type AgencyPortalConfigurationDto = AgencyConfigurationDto['agencyPortalConfiguration'];

export type AgencyPortalFeaturesDto = AgencyPortalConfigurationDto['agencyPortalFeatures'];

export async function fetchAgencyConfiguration(emsApi: Client<EmsPaths>): Promise<AgencyConfigurationDto> {
  const { data, response } = await emsApi.GET('/portal/v1/configuration');

  if (data === undefined) {
    throw new Error(`Failed to load agency configuration (HTTP ${response.status})`);
  }

  return data;
}
